import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import { PrescriptionTemplate } from "@/fluxvet/hooks/usePrescriptionTemplates";
import { convertTemplateToQuestionnaireResponse } from "./PostPrescriptionTemplate";

/**
 * Atualiza um modelo de prescrição existente no servidor FHIR
 * 
 * @param id - ID do QuestionnaireResponse a atualizar
 * @param template - Dados atualizados do modelo (sem id, createdAt, updatedAt)
 * @param organizationId - ID da organização
 * @param userId - ID do usuário que está atualizando
 * @returns QuestionnaireResponse atualizado
 */
export async function PutPrescriptionTemplate(
  id: string,
  template: Omit<PrescriptionTemplate, "id" | "createdAt" | "updatedAt">,
  organizationId: string,
  userId: string
) {
  const questionnaireResponse = convertTemplateToQuestionnaireResponse(
    template,
    organizationId,
    userId
  );

  // Adiciona o ID para o PUT
  const updatedQuestionnaireResponse = {
    ...questionnaireResponse,
    id: id,
  };

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(
      `${endpoints.ADMFHIR}/QuestionnaireResponse/${id}`,
      updatedQuestionnaireResponse,
      {
        headers,
        timeout: 20000,
      }
    )
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PutPrescriptionTemplate: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PutPrescriptionTemplate Error:", error);
      throw new Error(
        `Erro ao atualizar modelo: ${error?.response?.status || "Desconhecido"}`
      );
    });

  return response;
}
